/* ============================================================
   DOORWEDGE — base scripts
   Cart drawer, AJAX add-to-cart, one-click buy, gallery, nav.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.DW && window.DW.moneyFormat;
    var value = (cents / 100).toFixed(2);
    if (!fmt) return '$' + value;
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
  };

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 3200);
  }

  /* ---------- mobile nav ---------- */
  var navToggle = $('[data-nav-toggle]');
  var mobileNav = $('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('a', mobileNav).forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-drawer]');
  var overlay = $('[data-drawer-overlay]');
  var drawerBody = $('[data-drawer-body]');
  var drawerFoot = $('[data-drawer-foot]');
  var drawerTotal = $('[data-drawer-total]');
  var lastFocus = null;
  var lockedScrollY = 0;

  /* iOS Safari ignores overflow:hidden on <body>, so pin the page instead. */
  function lockScroll() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.classList.add('drawer-locked');
  }

  function unlockScroll() {
    document.body.classList.remove('drawer-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderDrawer(cart) {
    if (!drawerBody) return;
    updateCount(cart.item_count);

    if (!cart.items.length) {
      drawerBody.innerHTML = '<div class="drawer-empty"><p>Your cart is empty.</p></div>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }

    drawerBody.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + sized(item.image, 160) + '" alt="" loading="lazy">'
        : '<div></div>';
      return '<div class="drawer-line">' + img +
        '<div><b>' + escapeHtml(item.product_title) + '</b>' +
        '<small>Qty ' + item.quantity + '</small>' +
        '<button type="button" class="drawer-remove" data-remove="' + item.key + '">Remove</button></div>' +
        '<div class="cart-line-price">' + money(item.final_line_price) + '</div></div>';
    }).join('');

    if (drawerFoot) drawerFoot.hidden = false;
    if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    var close = $('[data-drawer-close]', drawer);
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  $$('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then(function (cart) { renderDrawer(cart); openDrawer(); });
    });
  });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer();
  });

  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn) return;
      btn.textContent = 'Removing...';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: btn.getAttribute('data-remove'), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderDrawer);
    });
  }

  /* ---------- add to cart / buy now ---------- */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  function scopeOf(btn) {
    return btn.closest('[data-product-form]') || btn.closest('form') || null;
  }

  function currentQty(scope) {
    var input = scope ? $('[data-qty-input]', scope) : null;
    return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
  }

  $$('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var scope = scopeOf(btn);
      var label = btn.innerHTML;
      btn.setAttribute('aria-disabled', 'true');
      btn.innerHTML = 'Adding...';
      addToCart(id, currentQty(scope))
        .then(fetchCart)
        .then(function (cart) {
          renderDrawer(cart);
          openDrawer();
          btn.innerHTML = label;
          btn.removeAttribute('aria-disabled');
        })
        .catch(function (err) {
          btn.innerHTML = label;
          btn.removeAttribute('aria-disabled');
          toast(err.message);
        });
    });
  });

  /* One-click: add then go straight to checkout. */
  $$('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var scope = scopeOf(btn);
      var label = btn.innerHTML;
      btn.setAttribute('aria-disabled', 'true');
      btn.innerHTML = 'One moment...';
      addToCart(id, currentQty(scope))
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          btn.innerHTML = label;
          btn.removeAttribute('aria-disabled');
          toast(err.message);
        });
    });
  });

  /* ---------- quantity stepper ---------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('[data-qty-input]', wrap);
    if (!input) return;
    $$('[data-qty-step]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var next = (parseInt(input.value, 10) || 1) + step;
        var max = parseInt(input.getAttribute('max'), 10);
        if (next < 1) next = 1;
        if (max && next > max) next = max;
        input.value = next;
      });
    });
  });

  /* ---------- product gallery ---------- */
  var mainImg = $('[data-gallery-main]');
  if (mainImg) {
    $$('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (src) mainImg.src = src;
        $$('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- sticky buy bar ---------- */
  var sticky = $('[data-sticky-buy]');
  var stickyAnchor = $('[data-sticky-anchor]');
  if (sticky && stickyAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(stickyAnchor);
  }

  /* ---------- keep counts fresh on load ---------- */
  if (document.querySelector('[data-cart-count]')) {
    fetchCart().then(function (cart) { updateCount(cart.item_count); }).catch(function () {});
  }
})();
